export const ACCOUNT_CLOSURE_PATHNAME_MAPPER = {
  OTHER_OPTIONS: "/account-closure/other-options",
  DEMAT_CLOSE: "/account-closure/demat-close",
  DEMAT_CLOSE_REASON: "/account-closure/reason",
  CHECKLIST_SCREEN: "/account-closure/checklist",
  CLOSURE_INIT: "/account-closure/init",
  CLOSURE_APPROVED: "/account-closure/approved",
  CLOSURE_VERIFED: "/account-closure/verified",
  ESIGN_LANDING: "/account-closure/esign-landing",
  ESIGN_STATUS: "/account-closure/esign-status",
  MANUAL_SIGNATURE: "/account-closure/manual-signature",
  OTP_SCREEN: "/account-closure/otp",
};

export const ACCOUNT_CLOSURE_LANDING_BOTTOMSHEET = {
  closureEsignPending: {
    id: "closureEsignPending",
    dataAid: "esignPending",
    title: "Account closure request approved",
    subtitle: "Now eSign to close Trading & Demat account",
    buttonTitle: "esign",
    oneButton: true,
    icon: "iv_closure_approved.svg",
  },
  closureRejected: {
    id: "closureRejected",
    dataAid: "closureRejected",
    title: "Account closure rejected",
    subtitle: "Complete pending actions to proceed",
    button2Title: "later",
    buttonTitle: "check now",
    icon: "iv_closure_rejected.svg",
  },
  closureInProgress: {
    id: "closureInProgress",
    dataAid: "closureInProgress",
    title: `Trading & Demat account closure is in progress`,
    subtitle: `Access to Stocks, IPO and F&O is now restricted`,
    buttonTitle: "Okay",
    oneButton: true,
    icon: "iv_closure_pending.svg",
  },
};
